import {ChangeDetectionStrategy, Component, ElementRef, inject, input, output, signal} from '@angular/core';

@Component({
    selector: 'app-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
      '(document:click)': 'onClick($event)'
    }
})
export class DropdownComponent {
  private readonly elementRef = inject(ElementRef);

  public readonly arrowOffset = input<number>();
  public readonly arrowBackgroundColour = input<string>();
  public readonly ignoreClass = input<string>();
  public readonly closeOnClick = input<boolean>(false);

  public readonly aboveTrigger = signal(false);
  public readonly leftOfTrigger = signal(false);
  public readonly showDropdown = signal(false);
  public readonly clickEvent = output<Event>();

  public onClick(event: Event): void {

    if (this.closeOnClick()) {
      this.clickEvent.emit(event);
      return;
    }

    let containsIgnoredClass = false;
    const clickedInside = this.elementRef.nativeElement.contains(event.target);

    if (event.target) {
      const targetElement = event.target as HTMLElement;
      containsIgnoredClass = targetElement.classList.contains(this.ignoreClass() ?? '');
    }

    if (!clickedInside && !containsIgnoredClass) {
      this.clickEvent.emit(event);
    }
  }

  public toggleDropdown(): void {
    this.showDropdown.set(!this.showDropdown());
  }

  public hideDropdown(): void {
    this.showDropdown.set(false);
  }
}
